// extracted by mini-css-extract-plugin
export default {"tribute":"TributeCandleFlower_tribute__lhEOm","button_container":"TributeCandleFlower_button_container__GoD4P"};